export const isInteger = (value: number) => {
  return Number.isInteger(+value) || 'value is not Integer';
};
